import React from 'react';
import { IService } from 'interfaces/services';
import Status from 'components/Status/Status';
import { convertDurationForFE } from 'utils/convertDuration';
import { ReactComponent as DragHandleIcon } from 'assets/icons/drag_handle.svg';
import { ReactComponent as MoveButtonIcon } from 'assets/icons/move-button.svg';

interface IProps {
  service: IService;
  header: React.ReactNode;
  currentIndex: number;
  onMoveUp: (index: number) => void;
  onMoveDown: (index: number) => void;
  totalItems: number;
  nextItemIsInactive?: boolean;
}

const ServiceOrder = ({
  service,
  header,
  currentIndex,
  onMoveUp,
  onMoveDown,
  totalItems,
  nextItemIsInactive = false,
}: IProps) => {
  const { displayName, name, isActive, duration } = service;

  const nameDisplay = displayName ? displayName : name;
  const canMoveUp = currentIndex > 0;
  const canMoveDown = currentIndex < totalItems - 1 && !nextItemIsInactive;

  const handleMoveButton = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    isMoveUp: boolean
  ) => {
    e.stopPropagation();
    isMoveUp ? onMoveUp(currentIndex) : onMoveDown(currentIndex);
  };

  return (
    <div className="px-2 py-1.4 flex w-full">
      <DragHandleIcon className="all-child:all-child:fill-mid-grey h-2.1 mr-1 self-center" />
      <div className="flex flex-1 justify-between">
        <div className="flex-1 max-w-[21rem]">
          {header ? (
            header
          ) : (
            <p className="text-16 leading-[2.4rem] font-bold ">
              <span>{nameDisplay}</span>
            </p>
          )}
          <p className="text-14 leading-21 truncate text-darkest-grey">
            {convertDurationForFE(duration)} mins
          </p>
          <div className="mt-0.4">
            <Status isActive={isActive}>
              {isActive ? 'Active' : 'Inactive'}
            </Status>
          </div>
        </div>
        <div className="flex flex-col gap-y-1.2 self-center">
          <button
            onClick={(e) => handleMoveButton(e, true)}
            disabled={!canMoveUp}
            className={`group transition-transform duration-150 ease-out  ${!canMoveUp ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <MoveButtonIcon className="group-hover:all-path:fill-magenta-lighter group-hover:all-rect:stroke-magenta" />
          </button>
          <button
            onClick={(e) => handleMoveButton(e, false)}
            disabled={!canMoveDown}
            className={`group transition-transform duration-150 ease-out  ${!canMoveDown ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <MoveButtonIcon className="rotate-180 group-hover:all-path:fill-magenta-lighter group-hover:all-rect:stroke-magenta" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceOrder;
